const list = {
  path: 'messageClassList',
  component: resolve => require(['@/pages/admin/platform/message/messageClassList'], resolve)
}

export default list
